import { INVALID_PIN_CODE_ERROR } from "../constants";

export const hasInvalidPinCode = (error: string) =>
  error.includes(INVALID_PIN_CODE_ERROR);
